import React, { useEffect, useState } from 'react';
import { Card, CardHeader, Stack, CardBody, Text, Box, Heading, Flex, Icon, useBreakpointValue, VStack, SimpleGrid, List, ListItem, Button, Link, Center } from '@chakra-ui/react';
import { BsFileEarmark } from 'react-icons/bs';
import OrdersCard from './OrdersCard';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { FaExclamationCircle } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const OrderDetail = () => {
  const headingSize = useBreakpointValue({ base: '3xl', lg: '5xl' });
  const navigate = useNavigate();
  const location = useLocation();
  const order = location.state.order;
  const orderId = order.orderId;
  const status = order.workStatus;

  const [cardData, setCardData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrders = async () => {
      if (!orderId) {
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get("https://glb-api.onrender.com/sop/orders/detail", { params: { orderId: orderId }, withCredentials:true });
        console.log(response.data);
        setCardData(response.data);
        setLoading(false);
      } catch (error) {
        console.log(error);
        setError(error.response.data.message);
        setLoading(false);
      }
    };
    fetchOrders();
  }, [orderId]);

  console.log("OrderId:", orderId);

  const handleQnaClick = () =>{
    navigate('/qna', {state : {orderId : orderId}})
  }

  return (
    <Box width={'100%'} padding={'10px'}>
      {loading && <p>Loading...</p>}
      {cardData && (
        <Card width={'100%'}>
          <CardHeader bg={'gray.100'}>
            <Flex align="center">
              <Icon as={BsFileEarmark} boxSize={9} mr={2} mt={2} />
              <Heading as="h1" fontSize={headingSize}>
                Order #{cardData[0].orderId}
              </Heading>
            </Flex>
          </CardHeader>

          <CardBody>
            {cardData[0].qnaStatus ? (
              <>
              <Box >
<Card boxShadow="none">
  <CardHeader>
    <Stack >
      <Box mb={10}>
    {cardData.map((card) => (

<OrdersCard
  title={cardData[0].orderId}
  id={cardData[0].orderId}
  wordCount={card.wordCount}
  status={cardData[0].workStatus}
/>

))}
</Box>


    <Heading fontSize={"2xl"}>Order Summary</Heading>
    </Stack>
  </CardHeader>

  <CardBody>
  <VStack alignItems={'left'} marginTop={"30px"} marginBottom={"30px"}>
              <SimpleGrid
                columns={{ base: 2, md: 2 }}
                spacing={{ base: 20, md: 5 }}
                maxWidth={{ base: '100%', md: '50%' }}
              >
                <List spacing={2}>
                  <ListItem>Order ID</ListItem>
                  <ListItem>Order Type</ListItem>
                  <ListItem>Work Status</ListItem>
                  <ListItem>Service</ListItem>

                  <ListItem>Price</ListItem>
                  <ListItem>Payment Status</ListItem>
                  <ListItem>Qna status</ListItem>
                </List>
                <List spacing={2}>
                        <ListItem>{cardData[0].orderId}</ListItem>
                        <ListItem>Review SOP</ListItem>
                        <ListItem>{cardData[0].workStatus}</ListItem>
                        <ListItem>rewrite</ListItem>



                        <ListItem>{cardData[0].price}</ListItem>
                        <ListItem>{cardData[0].paymentStatus ? 'Paid' : 'Not Paid'}</ListItem>
                        <ListItem>{cardData[0].qnaStatus ? 'filled' : 'not filled'}</ListItem>

                      </List>
              </SimpleGrid>
            </VStack>
            <VStack spacing={6} alignItems="stretch">

              <Card key={cardData[0].orderId} boxShadow="md" borderRadius="md">
                <CardHeader>
                  <Text fontSize="xl" fontWeight="bold">
                    {/* {card.title} */}
                  </Text>
                </CardHeader>
                <CardBody>
                  <VStack alignItems="stretch" spacing={4}>
                    <Box>
                      <Heading as="h2" fontSize="lg">
                        Uploaded SOP
                      </Heading>
                      <Flex alignItems="center">
                        {/* <Icon as={BsFileEarmark} boxSize={6} mr={2} /> */}
                        <Text>
                        {cardData[0].sop}

                        </Text>
                        {/* <Link href={card.uploadedSOP.fileUrl} download={card.uploadedSOP.fileName}>
                          {card.uploadedSOP.fileName}
                        </Link> */}
                      </Flex>
                    </Box>
                    <Box>
                      <Heading as="h2" fontSize="lg">
                        Edited Final SOP
                      </Heading>
                      <Text>{cardData[0].sopMade}</Text>
                    </Box>
                  </VStack>
                </CardBody>
              </Card>

          </VStack>
  </CardBody>

</Card>
</Box>
              </>
            ) : (
              <Card boxShadow="none">
                <CardHeader>
                  <Center>
                <Flex alignItems="center">
                    <Icon as={FaExclamationCircle} boxSize={6} mr={2} color="red.500" />
                    <Text fontSize="xl" fontWeight="bold" color="red.500">
                      Q&A Form Not Filled
                    </Text>
                  </Flex>
                  </Center>
                </CardHeader>
                <CardBody>
                  <VStack alignItems="center" spacing={4}>
                    <Text>
                      You have not filled the Q&A form yet to complete your order.
                      Please fill out the SOP.
                    </Text>
                    <Button colorScheme="blue" as="a" onClick={handleQnaClick}>
  Fill Q&A Form
</Button>


                  </VStack>
                </CardBody>
              </Card>
            )}
          </CardBody>
        </Card>
      )}
    </Box>
  );
};

export default OrderDetail;
